import React from 'react';
import DevSecOpsOfferPage from './DevSecOpsOfferPage';

const DevSecOpsWeekly = () => (
    <DevSecOpsOfferPage
        scope="Core"
        icon="las la-user-shield"
        summary="DevSecOps ONE Core provides greater delivery capacity and continuity across development, infrastructure, automation, and security expertise — as a one-time engagement or a recurring service."
        oneTimePrice="$3,900.00"
        recurringPrice="$3,267"
        purchaseUrl="https://my.epicfinal.com/index.php?rp=/store/managed-services/devsecops-one-weekly-subscription"
        oneTimeDescription="Ideal for a focused project, sprint, setup, major upgrade, migration, or complex technical engagement."
        recurringDescription="An ongoing technology partner with a higher delivery cadence and continuity over time."
    />
);

export default DevSecOpsWeekly;
